import { render, staticRenderFns } from "./PagePassword.vue?vue&type=template&id=f1892bc0"
import script from "./PagePassword.vue?vue&type=script&lang=js"
export * from "./PagePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports